export default "/images/f9edfe705285214eb6f44ad8854aee50.avif";